module.exports = __webpack_public_path__ + "static/media/check-icon-white.8b23974b.svg";